import {useAppDispatch, useAppSelector} from "../../reducers/hooks";
import {FormattedMessage, useIntl} from "react-intl";
import React, {MouseEvent, useEffect, useMemo, useState} from "react";
import {ColumnDef, ColumnFiltersState} from "@tanstack/react-table";
import {deleteElement, DogElement, getAllElementDead} from "../../reducers/Dog/DogReducer";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {openSnackbar, SnackbarState} from "../../reducers/snackbar/snackbarReducer";
import Grid from "@mui/material/Grid";
import {TablePagination} from "@mui/material";
import BasicTableCustom from "../../components/tables/BasicTableCustom";
import CustomLoader from "../../components/CustomLoader";

export default function Dead() {
    const dispatch = useAppDispatch()
    const intl = useIntl()

    // module for componet
    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filters, setFilters] = useState<ColumnFiltersState | null>([])
    const [selectedElement, setSelectedElement] = useState<DogElement | null>(null);

    const [searchTerms, setSearchTerms] = useState<Record<string, string>>({
        name: "",
        microchipCode: "",
        municipalityId: "",
        sex: "",
        coatColor: "",
        status: "",
        race: "",
        nameBox: "",
        nameShed: "",
        sterilizationDate: ""
    });
    const {elements, currentPage, totalRows, loading, sort} = useAppSelector((state) => state.DogElement);

    const columns = useMemo<ColumnDef<DogElement>[]>(() => {
        return [
            {
                header: intl.formatMessage({id: "Preview"}),
                accessorKey: 'photoProfil',
                enableColumnFilter: false,
                cell: ({row}) => {
                    const base64 = row.original.photoProfil;
                    return base64 ? (
                        <img
                            src={base64}
                            alt="Preview"
                            style={{width: '100px', height: 'auto', objectFit: 'cover'}}
                        />
                    ) : (
                        <span>Image not available</span>
                    );
                }
            },
            {
                header: intl.formatMessage({id: 'Name'}),
                accessorKey: 'name'
            },
            {
                header: intl.formatMessage({id: 'MicrochipCode'}),
                accessorKey: 'microchipCode',
                minSize: 180

            },
            {
                header: intl.formatMessage({id: 'Municipality'}),
                accessorKey: 'municipalityId',
                enableColumnFilter: false,
            },
            {
                header: intl.formatMessage({id: 'Sex'}),
                accessorKey: 'sex',
                enableColumnFilter: false,
            },
            {
                header: intl.formatMessage({id: 'Coat Color'}),
                accessorKey: 'coatColor',
                enableColumnFilter: false,
            },
            /*{
                header: intl.formatMessage({id: 'Status'}),
                accessorKey: 'dogStatusType',
                enableColumnFilter: false,
            },*/
            {
                header: intl.formatMessage({id: 'Sterilization Date'}),
                accessorKey: 'sterilizationDate',
                enableColumnFilter: false,
            },
            {
                header: intl.formatMessage({id: 'Died Date'}),
                accessorKey: 'diedDate',
                enableColumnFilter: false

            },
            {
                header: intl.formatMessage({id: 'Race'}),
                accessorKey: 'race',
                enableColumnFilter: false,
            },
            {
                header: () => <FormattedMessage id="Actions" defaultMessage="Actions"/>,
                enableColumnFilter: false,
                accessorKey: 'Actions',
                cell: ({row}) => {
                    const dog = row.original;

                    const handlePrint = () => {

                        const printContent = `
        <html>
        <head>
            <title>Stampa</title>
            <style>
             body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            margin: 0;
            padding: 0;
            background-color: #f9f9f9;
        }
        .header {
            text-align: center;
            padding: 20px;
            background-color: #007bff;
            color: #fff;
            font-size: 24px;
            font-weight: bold;
        }
        .content {
            padding: 20px;
        }
        .dog-card {
            background: #fff;
            border: 1px solid #ddd;
            border-radius: 8px;
            padding: 15px;
            margin-bottom: 20px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        .dog-card p {
            margin: 8px 0;
            font-size: 14px;
        }
        .dog-card strong {
            color: #555;
        }
        .dog-card ul {
            padding-left: 20px;
            margin: 10px 0;
        }
        .dog-card ul li {
            margin-bottom: 8px;
        }
        .section-title {
            font-size: 18px;
            font-weight: bold;
            color: #007bff;
            margin-bottom: 10px;
            border-bottom: 2px solid #007bff;
            padding-bottom: 5px;
        }
        .dog-info {
            margin-bottom: 15px;
        }
        img {
            max-width: 150px;
            height: auto;
            display: block;
            margin-bottom: 10px;
        }
            </style>
        </head>
        <body>
 <div class="dog-card">
                <div class="section-title">Informazioni Generali</div>
                <p><strong>Municipio di Provenienza:</strong> ${dog.municipalityId || 'N/A'}</p>
                <p><strong>Nome:</strong> ${dog.name || 'N/A'}</p>
                <p><strong>Microchip Code:</strong> ${dog.microchipCode || 'N/A'}</p>
                <p><strong>Data Cattura:</strong> ${dog.catchingDate || 'N/A'}</p>
                <p><strong>Stato Salute:</strong> ${dog.catchingHealthStatus || 'N/A'}</p>
                <p><strong>Data Morte:</strong> ${dog.diedDate || 'N/A'}</p>
                <p><strong>Sesso:</strong> ${dog.sex || 'N/A'}</p>
                <p><strong>Razza:</strong> ${dog.race || 'N/A'}</p>
                <p><strong>Data di Nascita Presunta:</strong> ${dog.bornDate || 'N/A'}</p>
                <p><strong>Colore Mantello:</strong> ${dog.coatColor || 'N/A'}</p>
                <p><strong>Taglia:</strong> ${dog.sizeDog || 'N/A'}</p>

                <div class="section-title">Informazioni Box</div>
                <p><strong>Box di Appartenenza:</strong> ${dog.box?.name || 'N/A'}</p>
                <p><strong>Capannone:</strong> ${dog.box?.shedName || 'N/A'}</p>

                <div class="section-title">Trattamenti</div>
                <ul>
                    ${
                            dog.treatments && dog.treatments.length > 0
                                ? dog.treatments.map(treatment => `
                                <li>
                                    <strong>Nota:</strong> ${treatment.notes || 'N/A'}<br />
                                    <strong>Data:</strong> ${treatment.executionDate || 'N/A'}
                                </li>
                              `).join('')
                                : '<li>Nessun trattamento per questo cane</li>'
                        }
                </ul>
            </div>        </body>
        </html>`
                        const printWindow = window.open('', '_blank');
                        printWindow?.document.write(printContent);
                        printWindow?.print();
                        printWindow?.close();
                    };

                    return (
                        <Stack direction="row" spacing={1}>
                            {/* <Tooltip title="Edit">
                                <IconButton
                                    color="primary"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedElement(dog);
                                        setOpen(true);
                                    }}
                                >
                                    <Edit/>
                                </IconButton>
                            </Tooltip>*/}

                            <Tooltip title="Print">
                                <IconButton
                                    color="default"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handlePrint();
                                    }}
                                >
                                    🖨️
                                </IconButton>
                            </Tooltip>
                        </Stack>
                    );
                }
            }
        ];
    }, [intl]);

    useEffect(() => {
        dispatch(getAllElementDead({
            pageableDto: {page: page, size: rowsPerPage, sort: ['dateCreated', 'desc']},
            filters: filters
        }));
    }, [page, rowsPerPage, JSON.stringify(filters)]);


    const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => setPage(newPage);
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleModalOpen = (isOpen: boolean) => {
        setOpen(isOpen);
        if (!isOpen) setSelectedElement(null);
    };

    const columnFiltersState = (values: ColumnFiltersState) => {
        setPage(0)
        setFilters(values)
    };

    const onDeleteSuccess = () => {
        dispatch(getAllElementDead({pageableDto: {page: currentPage, size: rowsPerPage, sort}, filters: filters}));
        openSnackbar(
            {
                open: true,
                message: 'Element deleted successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            } as SnackbarState
        )
    }

    // capire come usare
    const handleDelete = (id: string) => dispatch(deleteElement({id, callback: onDeleteSuccess}));

    return (
        <>
            <CustomLoader open={loading} message="Caricamento in corso..."/>

            <Grid container>
                <Grid item xs={12}>
                    <BasicTableCustom
                        columns={columns}
                        data={elements}
                        title={intl.formatMessage({
                            id: "Number of dead:" + totalRows,
                            defaultMessage: "Numero dei cani morti: " + totalRows
                        })}
                        striped
                        modalToggler={() => handleModalOpen(!open)}
                        onFilterChange={columnFiltersState}
                        manualFiltering={true}
                    />
                    <TablePagination
                        component="div"
                        count={totalRows}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />


                    {/* {selectedDeleteElement && (
                    <AlertExampleElementDelete
                        id={selectedDeleteElement._id}
                        title={selectedDeleteElement.name}
                        open={deleteAlertOpen}
                        handleClose={() => setDeleteAlertOpen(false)}
                        onDelete={(id) => handleDelete(id)}
                    />
                )}*/}
                </Grid>
            </Grid>
        </>
    )
}